/**
 * 购买模块，调整到购买页
 */

import qs from 'qs';

/**
 * 获取购买页地址
 * @param {string} buyUrl buy页面地址
 * @param {object} config 产品配置
 * @returns {string} buy url
 */
function getBuyUrl(buyUrl, config) {
  const params = qs.stringify(config);
  // const params = encodeURIComponent(JSON.stringify(config)) ;

  // console.log(JSON.stringify(config))
  // console.log(decodeURI(params))
  return buyUrl + `?${params}`;
  // return buyUrl + (buyUrl.indexOf('?') > -1 ? '' : '?')  + `${params}`;
}

export {getBuyUrl} ;


// WEBPACK FOOTER //
// ./lib/services/services/buy.js